import { CitedChunk, SectionSource } from 'models/AIArtifact';

/**
 * Build a `chunkId -> page` lookup from a summary or comparison's top-level
 * `chunks` array. Used to resolve citation hover-preview pages.
 */
export function buildChunkPageMap(chunks: CitedChunk[] | undefined): Record<string, number> {
  const map: Record<string, number> = {};
  for (const chunk of chunks ?? []) {
    map[chunk.id] = chunk.page;
  }
  return map;
}

/**
 * For one section, return `attachmentId -> pages[]` (every cited chunk's page
 * for that attachment in that section, ordered as cited and de-duplicated).
 * Sections without `sources` (legacy artifacts) yield an empty map and the
 * badge falls back to the filename tooltip.
 */
export function buildPagesByAttachmentId(
  sources: SectionSource[] | undefined,
  chunkPageById: Record<string, number>
): Record<string, number[]> {
  return Object.fromEntries(
    (sources ?? []).flatMap((source) => {
      const seen = new Set<number>();
      const pages: number[] = [];
      for (const chunkId of source.chunkIds ?? []) {
        const page = chunkPageById[chunkId];
        if (typeof page === 'number' && !seen.has(page)) {
          seen.add(page);
          pages.push(page);
        }
      }
      return pages.length ? [[source.attachmentId, pages]] : [];
    })
  );
}
